import type { TargetListItem } from "./types";

const DatabaseName = "skyview-web";
const StoreName = "state";
const TargetListKey = "targetList";

export async function loadTargetList(): Promise<TargetListItem[]> {
  return (await getValue<TargetListItem[]>(TargetListKey)) ?? [];
}

export async function saveTargetList(items: TargetListItem[]): Promise<void> {
  await setValue(TargetListKey, items);
}

async function getValue<T>(key: string): Promise<T | undefined> {
  const db = await openDatabase();
  return new Promise((resolve, reject) => {
    const request = db.transaction(StoreName, "readonly").objectStore(StoreName).get(key);
    request.onsuccess = () => resolve(request.result as T | undefined);
    request.onerror = () => reject(request.error);
  });
}

async function setValue<T>(key: string, value: T): Promise<void> {
  const db = await openDatabase();
  return new Promise((resolve, reject) => {
    const request = db.transaction(StoreName, "readwrite").objectStore(StoreName).put(value, key);
    request.onsuccess = () => resolve();
    request.onerror = () => reject(request.error);
  });
}

function openDatabase(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DatabaseName, 1);
    request.onupgradeneeded = () => {
      request.result.createObjectStore(StoreName);
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}
